export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-magnifying-glass-ea473a0f4d24948db8697b209d2622a8.svg";